import { render, staticRenderFns } from "./reset-request.vue?vue&type=template&id=2dd4bcb0"
import script from "./reset-request.vue?vue&type=script&lang=js"
export * from "./reset-request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports